export default __webpack_public_path__ + "static/media/project-greyarea.efe6aad8.png";